export enum AnalyzeEconomyDisplayType {
  Sum = 'Sum',
  Category= 'Category'
}
